import React from "react";
import Loader from "../../components/Loader";

const VendorSelector = ({ vendors, loadingVendors, value, onChange }) => {
  return (
    <div className="space-y-2 max-w-md">
      <label className="block text-sm font-medium text-gray-500 dark:text-gray-400">
        Vendor Assignment
      </label>
      {loadingVendors ? (
        <div className="flex items-center justify-center p-3">
          <Loader />
          <span className="ml-2 text-sm text-gray-500 dark:text-gray-400">
            Loading vendors...
          </span>
        </div>
      ) : (
        <select
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          className="block text-gray-700 dark:text-gray-200 w-full rounded-md border-gray-300 dark:border-gray-600 dark:bg-gray-800 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
        >
          <option className="text-xm" value="">
            Select a vendor...
          </option>
          {vendors.map((vendor) => (
            <option key={vendor.vendorID} value={vendor.vendorID}>
              {vendor.name} ({vendor.vendorID})
            </option>
          ))}
        </select>
      )}
      {vendors.length === 0 && !loadingVendors && (
        <p className="text-sm text-gray-500 dark:text-gray-400">No vendors available</p>
      )}
    </div>
  );
};

export default VendorSelector;
